<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <div class="ivu-tabs-tabpane" style="visibility: visible;">
          <div data-v-75eea3a4="" class="ivu-pb">
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所名称</p>
                <div data-v-75eea3a4="">{{form_data.name}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所类型</p>
                <div data-v-75eea3a4="">{{form_data.type_name}}</div>
              </div>
            </div>
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所编码</p>
                <div data-v-75eea3a4="">{{form_data.place_sn}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">所属类别</p>
                <div data-v-75eea3a4="">{{form_data.industry_id}}</div>
              </div>
            </div>
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">属地信息</p>
                <div data-v-75eea3a4="">{{form_data.community_name}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">地址</p>
                <div data-v-75eea3a4="">{{form_data.doorplate_address}}</div>
              </div>
            </div>
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">负责人</p>
                <div data-v-75eea3a4="">{{form_data.charge}}</div>
              </div>
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">手机号</p>
                <div data-v-75eea3a4="">{{form_data.iphone}}</div>
              </div>
            </div>
            <div data-v-75eea3a4="" class="row">
              <div data-v-75eea3a4="" class="col">
                <p data-v-75eea3a4="" class="label">场所照片</p>
                <div data-v-75eea3a4="">
                  <div data-v-75eea3a4="" class="flex flex-wrap"><span data-v-75eea3a4="" class="ivu-avatar ivu-avatar-square ivu-avatar-image">
                      <img style="width: 80px; height: 80px; line-height: 80px; font-size: 40px;" :src="facade_photo">
                    </span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="物资明细" name="second">
        <l-table :data="inspect_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
          <el-table-column fixed prop="inspect_sn" label="分类代码" min-width="150"> </el-table-column>
          <el-table-column fixed prop="inspect_sn" label="物资名称" min-width="150"> </el-table-column>
          <el-table-column fixed prop="inspect_sn" label="型号规格" min-width="150"> </el-table-column>
          <el-table-column prop="created_at" label="最近点检时间" min-width="150"> </el-table-column>
          <el-table-column prop="apleet_name" label="检查人姓名" min-width="150"> </el-table-column>
          <el-table-column label="检查结果" min-width="180">
            <template slot-scope="{ row }">
              完好数量：{{row.new_count}} 缺损数量：{{row.review_count}}
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>

      <el-tab-pane label="检查记录明细" name="third">
        <l-table :data="inspect_data" v-loading="loading" row-key="id" style=" max-height: 30vh;">
          <el-table-column fixed prop="inspect_sn" label="流水线" min-width="150"> </el-table-column>
          <el-table-column prop="created_at" label="提交时间" min-width="150"> </el-table-column>
          <el-table-column prop="apleet_name" label="提交人姓名" min-width="150"> </el-table-column>
          <el-table-column label="检查结果" min-width="180">
            <template slot-scope="{ row }">
              新增隐患：{{row.new_count}} 复查隐患：{{row.review_count}} 整改隐患：{{row.rectify_count}}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="resource_edit_btn" @click="checkInfo(row.inspect_sn)"><i class="el-icon-edit"></i>详情</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="primary" auth="resource_del_btn" @click="download(row.inspect_sn)"><i class="el-icon-download"></i>下载</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>
      </el-tab-pane>

      <el-tab-pane label="使用记录明细" name="fourth">

        <l-table :data="hidden_data" v-loading="loading" row-key="id" style="max-height: 30vh;">
          <el-table-column prop="rectification" label="使用登记/归还登记" min-width="100"> </el-table-column>
          <el-table-column prop="created_at" label="登记时间" width="120"> </el-table-column>
          <el-table-column prop="created_uid" label="登记人员" width="100"> </el-table-column>
          <el-table-column label="照片记录" min-width="300">
            <template slot-scope="{ row }">
              <img style="width: 80px; height: 80px; line-height: 80px; font-size: 40px;" v-for="(item, index) in row.photo" :key="index" :src="item" />
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="150" align="center">
            <template slot-scope="{ row }">
              <l-auth-text-button type="primary" auth="resource_edit_btn" @click="hiddenInfo(row)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
              <span class="l-action-separator">|</span>
              <l-auth-text-button type="danger" auth="resource_del_btn" @click="hiddenDel(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
            </template>
          </el-table-column>
        </l-table>

      </el-tab-pane>

    </el-tabs>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
    </div>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="消防检查记录详情" width="1000px">
      <l-check-info :visible.sync="info_visible" :id="inspect_sn" :place_id="id" is-info />
    </l-dialog>

    <!--修改隐患内容-->
    <l-dialog :visible.sync="hidden_edit_visible" title="修改隐患内容" width="1000px">
      <l-hidden-edit :visible.sync="hidden_edit_visible" :id="hidden_id" :hidden-list="hidden_list" :place_id="id" @on-success="onEditSucess"/>
    </l-dialog>
  </div>

</template>

<script>
import Info from "./check_info";
import HiddenEdit from "./hidden_edit";
import { PLACE_LOG ,Grade} from "./place";

export default {
  name: 'l-place-info',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
    [Info.name]: Info,
    [HiddenEdit.name]:HiddenEdit
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
      },
      inspect_sn: '',
      place_id:'',
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {},

      inspect_data: [],
      hidden_data: [],
      place_log: [],
      PLACE_LOG: PLACE_LOG,
      danger_data: [],
      Grade:Grade,
      info_visible: false,
      hidden_edit_visible:false,//修改隐患内容
      info_name: "",
      hidden_id:"",
      hidden_list:[]
    }
  },
  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {

    },
    //消防检查记录详情
    checkInfo(inspect_sn) {
      this.inspect_sn = inspect_sn;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    // //消防检查记录详情  下载 
    // download(id) {
    //   this.export_loading = true;
    //   this.$_invoke('placeExport_xfCheckExport', { inspect_sn: id })
    //     .then((ret) => {
    //       window.open(ret);
    //     })
    //     .finally(() => {
    //       this.export_loading = false;
    //     });
    // },
    //获取数据
    getData() {
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`site_getInfoData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.facade_photo = ret.data.facade_photo;
          this.danger_notification_photo = ret.data.danger_notification_photo;
          this.signature_photo = ret.work.signature_photo;
          this.sign_for_photo = ret.work.sign_for_photo;
          this.work_photo = ret.work.work_photo;
          this.inspect_data = ret.fire_inspection_log;
          this.hidden_data = ret.hidden_data;
          this.place_log = ret.place_log;
          this.danger_data = ret.charge;
        }).finally(() => {
          this.loading = false;
        });

      }
    },
    inspectInfo() {
      // // console.log(row);
    },
    //隐患明细编辑
    hiddenInfo(row){
      this.hidden_list=row
      this.hidden_id=row.id
      this.hidden_edit_visible=true
    },
    //删除
    hiddenDel(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`site_delHidden`, { hidden_id:id }).then(() => {
            this.$_msg.success("删除成功");
            this.getData();
          });
        })
        .catch(() => { });
    },
    //编辑成功回调
    onEditSucess() {
      
      this.hidden_edit_visible = false;
      this.getData();
    },



  },
}
</script>